module.exports = __webpack_public_path__ + "img/poster-1.192c456b.png";